import { withRouter } from '~HOC';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { CloseIcon, RightIcon, LeftIcon } from '~svg';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isTripord } from '../../../../utils/consts/general';
import { flightBookingRoutes } from '../../../../utils/consts';
import { passengersCount } from '../../../../utils/utility/booking';
import {
  StackHolder,
  TravelerList,
  FlightInfoCard,
  PassengerCount,
  SearchTimeout,
  CountDownTimer,
} from '../../../../component';
import './flightSidebar.scss';

// Import all avatar images
import avatar1 from '../../../../content/images/avatars/1.png';
import avatar2 from '../../../../content/images/avatars/2.png';
import avatar3 from '../../../../content/images/avatars/3.png';
import avatar4 from '../../../../content/images/avatars/4.png';
import avatar5 from '../../../../content/images/avatars/5.png';
import avatar6 from '../../../../content/images/avatars/6.png';
import avatar7 from '../../../../content/images/avatars/7.png';
import avatar8 from '../../../../content/images/avatars/8.png';
import avatar9 from '../../../../content/images/avatars/9.png';
import avatar10 from '../../../../content/images/avatars/10.png';
import avatar11 from '../../../../content/images/avatars/11.png';
import avatar12 from '../../../../content/images/avatars/12.png';
import avatar13 from '../../../../content/images/avatars/13.png';
import avatar14 from '../../../../content/images/avatars/14.png';
import avatar15 from '../../../../content/images/avatars/15.png';
import avatar16 from '../../../../content/images/avatars/16.png';
import avatar18 from '../../../../content/images/avatars/18.png';
import avatar19 from '../../../../content/images/avatars/19.png';
import avatar20 from '../../../../content/images/avatars/20.png';
import avatar21 from '../../../../content/images/avatars/21.png';
import avatar22 from '../../../../content/images/avatars/22.png';
import avatar23 from '../../../../content/images/avatars/23.png';
import avatar24 from '../../../../content/images/avatars/24.png';
import avatar26 from '../../../../content/images/avatars/26.png';
import avatar27 from '../../../../content/images/avatars/27.png';
import avatar28 from '../../../../content/images/avatars/28.png';
import avatar29 from '../../../../content/images/avatars/29.png';
import avatar30 from '../../../../content/images/avatars/30.png';
import avatar31 from '../../../../content/images/avatars/31.png';
import avatar32 from '../../../../content/images/avatars/32.png';
import avatar33 from '../../../../content/images/avatars/33.png';
import avatar34 from '../../../../content/images/avatars/34.png';
import avatar35 from '../../../../content/images/avatars/35.png';
import avatar36 from '../../../../content/images/avatars/36.png';
import avatar37 from '../../../../content/images/avatars/37.png';
import avatar38 from '../../../../content/images/avatars/38.png';
import avatar39 from '../../../../content/images/avatars/39.png';
import avatar40 from '../../../../content/images/avatars/40.png';
import avatar41 from '../../../../content/images/avatars/41.png';
import avatar42 from '../../../../content/images/avatars/42.png';

// Import logo images
import tripordLogo from '../../../../content/images/icon/tripord-logo.webp';
import tripsiLogo from '../../../../content/images/icon/tripsi-logo.webp';

// Create avatar mapping
const avatarMap = {
  '1.png': avatar1,
  '2.png': avatar2,
  '3.png': avatar3,
  '4.png': avatar4,
  '5.png': avatar5,
  '6.png': avatar6,
  '7.png': avatar7,
  '8.png': avatar8,
  '9.png': avatar9,
  '10.png': avatar10,
  '11.png': avatar11,
  '12.png': avatar12,
  '13.png': avatar13,
  '14.png': avatar14,
  '15.png': avatar15,
  '16.png': avatar16,
  '18.png': avatar18,
  '19.png': avatar19,
  '20.png': avatar20,
  '21.png': avatar21,
  '22.png': avatar22,
  '23.png': avatar23,
  '24.png': avatar24,
  '26.png': avatar26,
  '27.png': avatar27,
  '28.png': avatar28,
  '29.png': avatar29,
  '30.png': avatar30,
  '31.png': avatar31,
  '32.png': avatar32,
  '33.png': avatar33,
  '34.png': avatar34,
  '35.png': avatar35,
  '36.png': avatar36,
  '37.png': avatar37,
  '38.png': avatar38,
  '39.png': avatar39,
  '40.png': avatar40,
  '41.png': avatar41,
  '42.png': avatar42,
};

let selectStakeholder = {},
  parsedQueryStr = '';
const INVALID_ROUTE = [
  flightBookingRoutes.selectFlight,
  flightBookingRoutes.identify,
  flightBookingRoutes.selectLoginType,
  flightBookingRoutes.flightInvoice,
];
class FlightSideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileMenu: [],
      selectedProfileId: '',
      profileType: '',
      businessImage: '',
      accountType: 'individual',
      expired: false,
    };
  }
  componentDidMount() {
    let currentProfile = null;
    let profile = localStorage.getItem('profile');
    if (localStorage.getItem('stakeholder')) {
      selectStakeholder = JSON.parse(localStorage.getItem('stakeholder'));
      currentProfile = this.props?.user?.profiles
        ? this?.props?.user?.profiles.filter((item, index) => {
            return item?.profile?.id == selectStakeholder;
          })[0]
        : null;
      // show panel for stakeholder or user name
      if (currentProfile) {
        currentProfile = currentProfile?.profile?.displayName?.name
          ? currentProfile?.profile?.displayName?.name
          : currentProfile?.profile?.displayName?.en;
        this.setState({
          currentProfile,
          selectedProfileId: profile
            ? profile !== 'individual'
              ? parseInt(profile)
              : profile
            : selectStakeholder
            ? parseInt(selectStakeholder)
            : 0,
        });
      } else {
        currentProfile = this.props.intl.formatMessage({
          id: 'profile.personalprofile',
        });
      }
    }

    this.setState({
      selectedProfileId: profile
        ? profile !== 'individual'
          ? parseInt(profile)
          : profile
        : selectStakeholder
        ? parseInt(selectStakeholder)
        : 0,
      profileType: currentProfile,
      allFlight: JSON.parse(sessionStorage.getItem('selectedAirport')),
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { searchTime, clearLocalStorage } = this.props;
    const { selectFlight } = this.state;
    if (searchTime !== nextProps.searchTime && nextProps.searchTime !== null) {
      this.setState({
        expired: false,
        searchAgain: false,
        closeTimeOut: false,
      });
    }
    if (nextProps.reload) {
      this.setState({
        allFlight: JSON.parse(sessionStorage.getItem('selectedAirport')),
      });
    }
    if (clearLocalStorage && Object.entries(selectFlight).length) {
      sessionStorage.removeItem('selectFlight');
      sessionStorage.removeItem('calendarPrice');

      this.setState({ selectFlight: {} });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll);
  }

  updateRoute = (key, value) => {
    const { currentPage, navigate } = this.props;
    parsedQueryStr[key] = value;
    parsedQueryStr.reset = '1';

    navigate(
      `${
        INVALID_ROUTE.includes(currentPage)
          ? flightBookingRoutes.selectFlight
          : currentPage
      }?${new URLSearchParams(parsedQueryStr).toString()}`,
    );

    let totalPassenger = passengersCount(parsedQueryStr);
    this.setState({ passengerCount: totalPassenger });
  };
  // change passenger in fix banner
  changePassengers = (temp, cabinName) => {
    if (temp) {
      return this.setState(
        { passengers: temp, searchAgain: true, cabinName },
        () => {
          if (temp.Adult != parsedQueryStr.ad)
            this.updateRoute('ad', temp.Adult.toString());
          if (temp['Child(Age 2-12)'] != parsedQueryStr.ch)
            this.updateRoute('ch', temp['Child(Age 2-12)'].toString());
          if (temp['Infant(Age 0-2)'] != parsedQueryStr.in)
            this.updateRoute('in', temp['Infant(Age 0-2)'].toString());
          if (cabinName !== parsedQueryStr?.cb)
            this.updateRoute('cb', cabinName);
          this.updateRoute('reset', 1);
          const { searchPassengers } = this.props;
          if (typeof searchPassengers === 'function') searchPassengers();
        },
      );
    }
  };

  render() {
    let {
      user,
      language,
      intl,
      currentPage,
      editPassenger,
      hasFilter,
      travelerList,
      hideFilterPanel,
      filterPanelFlag,
      backButtonClick,
      location,
      data,
    } = this.props;
    const { closeTimeOut, searchAgain, accountType, businessImage } =
      this.state;
    parsedQueryStr = Object.fromEntries(new URLSearchParams(location?.search));
    let { direction, name } = language;
    let { basicInfo } = user && user.user ? user.user[0] : {};
    let selectFlight = JSON.parse(sessionStorage.getItem('selectFlight')),
      passengerList = JSON.parse(sessionStorage.getItem('passengers')),
      searchTime = sessionStorage.getItem('searchTime'),
      isSearchFlightPage = currentPage === '/booking/select-flight',
      isFlightInvoicePage = currentPage === flightBookingRoutes.flightInvoice;

    return (
      <div
        style={{
          gap: 10,
          overflowY: filterPanelFlag ? 'scroll' : 'visible',
        }}
        className={`d-flex w-100  flight-side-bar-scroll flex-column  bg-primary curveBorder-${direction} p-3 `}
      >
        <div className="w-100 d-flex flex-column border-lg-bottom  border-light  text-white  align-items-start justify-content-center bg-primary position-relative">
          <div
            onClick={() => {
              hideFilterPanel();
            }}
            className="position-absolute d-md-block d-block d-lg-none text-third font-large"
            style={{
              top: 0,
              left: direction === 'rtl' ? 0 : '',
              right: direction === 'ltr' ? 0 : '',
            }}
          >
            <div className="mb-2 d-flex">
              <CloseIcon size={16} color="#f8f9fa" />
            </div>
          </div>
          {location.pathname.search('select-flight') == -1 ? (
            <div
              className={`d-flex w-100 px-2 justify-content-start  align-items-center cursor-pointer`}
              onClick={() => backButtonClick()}
            >
              {direction == 'rtl' ? (
                <RightIcon size={24} color="#85cd95" />
              ) : (
                <LeftIcon size={24} color="#85cd95" />
              )}
              <span className="px-2 text-white text-normal">
                <FormattedMessage id="booking.back" />
              </span>
            </div>
          ) : (
            ''
          )}
          <div className="d-lg-flex align-items-center pt-3 py-4 px-2  d-none  w-100 ">
            <div
              className="d-flex align-items-center justify-content-center rounded-circle avatar-img"
              style={{
                backgroundImage:
                  'conic-gradient(transparent, var(--secondary-light))',
              }}
            >
              <img
                className="rounded-circle bg-primary p-1 w-100 h-100"
                style={{
                  margin: '0.1rem',
                  objectFit: 'contain',
                }}
                src={
                  accountType === 'individual'
                    ? basicInfo
                      ? avatarMap[basicInfo?.avatar] || avatar1
                      : isTripord
                      ? tripordLogo
                      : tripsiLogo
                    : businessImage || (isTripord ? tripordLogo : tripsiLogo)
                }
                alt="avatar"
                onError={(e) => {
                  e.target.src = isTripord ? tripordLogo : tripsiLogo;
                }}
              />
            </div>
            {basicInfo ? (
              <div className="d-flex col-9 px-0 text-nowrap">
                <StackHolder
                  onChange={(selectedProfileType, profileData) => {
                    this.setState({
                      accountType: selectedProfileType,
                      businessImage: profileData?.image,
                    });
                  }}
                />
              </div>
            ) : (
              <div className="d-flex align-items-center">
                <div className="font-small px-2">
                  <FormattedMessage
                    id={`${isTripord ? 'user.tripord' : 'user.tripsi'}`}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        {searchTime ? (
          <div
            onClick={() =>
              this.state.expired
                ? this.setState(
                    {
                      searchAgain: true,
                      closeTimeOut: false,
                      expired: false,
                    },
                    () => {
                      this.props.changeStakHolder();
                    },
                  )
                : null
            }
            className={`d-lg-flex d-lg-block d-none pt-2 pb-3 px-2 border-bottom  border-light cursor-pointer text-white font-weight-bold text-captalize  align-items-center justify-content-between font-large`}
          >
            {window.innerWidth >= 992 && (
              <div className="w-50 d-flex border-lg-bottom  border-light  text-white  align-items-center justify-content-start bg-primary ">
                <CountDownTimer
                  intl={intl}
                  showSearchTimeOut={() => this.setState({ expired: true })}
                  closeTimeOut={closeTimeOut}
                  direction={direction}
                />
              </div>
            )}
            <div className="d-flex w-50 justify-content-end">
              {hasFilter && currentPage === '/booking/select-flight' && (
                <div
                  className="linkableDiv text-gold font-weight-bold font-smaller
                  pointer px-1 d-flex flex-end justify-content-end cursor-pointer"
                  onClick={() => this.props.clearFlightFilter()}
                >
                  <FormattedMessage
                    id="booking.clearallfilter"
                    defaultMessage="booking.clearallfilter"
                  />
                </div>
              )}
            </div>
          </div>
        ) : null}
        {/* CompanyLogo user={user} lang={language} /> */}

        <FlightInfoCard
          name={name}
          intl={intl}
          parsedQueryStr={parsedQueryStr}
          flightType={parsedQueryStr.ft}
          changePassengers={(item, cabinName) =>
            this.changePassengers(item, cabinName)
          }
        />

        {isSearchFlightPage ? (
          this.props.renderFilterPanel()
        ) : (
          <>
           

            <PassengerCount
              parsedQueryStr={parsedQueryStr}
              selectFlight={selectFlight}
              intl={intl}
              totalPrice={this.props.totalPrice}
            />
            {!isFlightInvoicePage && passengerList ||
            (!isFlightInvoicePage && travelerList.length && travelerList?.[0].firstName) ? (
              <TravelerList
                travelLst={passengerList || travelerList}
                data={[data]}
                editOnClick={editPassenger}
                direction={direction}
              />
            ) : (
              <></>
            )}
             {isFlightInvoicePage && (
              <div className="d-flex flex-column mb-4">
                <div 
                  className="d-flex justify-content-between align-items-center p-3 cursor-pointer text-white"
                  onClick={() => {
                    const { navigate } = this.props;
                    navigate(
                      `${flightBookingRoutes.identify}?${new URLSearchParams(
                        parsedQueryStr,
                      ).toString()}`,
                    );
                  }}
                >
                  <div className="font-weight-bold">
                    <FormattedMessage id="booking.editpassengersinfo" />
                  </div>
                  {direction === 'rtl' ? (
                    <LeftIcon size={20} color="#85cd95" />
                  ) : (
                    <RightIcon size={20} color="#85cd95" />
                  )}
                </div>
              </div>
            )}
          </>
        )}

        {this.state.expired && searchTime && !searchAgain && !closeTimeOut ? (
          <SearchTimeout
            key={'flight-sidebar'}
            titleMessage="booking.searchtimeout"
            errorMessage="booking.searchagaininfo"
            message="booking.searchagaininfomsg"
            headerMessage="booking.timeout"
            hideSearchTimeOut={() => {
              this.setState((state) => {
                state.expired = false;
                state.closeTimeOut = true;
                state.searchAgain = false;
                return state;
              });
            }}
            searchAgain={() => {
              this.setState(
                (state) => {
                  state.expired = false;
                  state.closeTimeOut = false;
                  state.searchAgain = true;
                  return state;
                },
                () => {
                  sessionStorage.removeItem('searchTime');
                  this.props.changeStakHolder();
                },
              );
            }}
          />
        ) : (
          <></>
        )}
      </div>
    );
  }
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
    user: state?.user?.userInfo,
  };
}
FlightSideBar.propTypes = {
  renderFilterPanel: propTypes.func,
  clearFlightFilter: propTypes.func,
  pageName: propTypes.string,
  parsedQueryStr: propTypes.object,
  hasFilter: propTypes.bool,
  travelerList: propTypes.array,
  hideFilterPanel: propTypes.func,
};
FlightSideBar.defaultProps = {
  renderFilterPanel: () => {
    return <></>;
  },
  clearFlightFilter: () => {
    return null;
  },
  pageName: '',
  parsedQueryStr: {},
  hasFilter: false,
  travelerList: [],
  hideFilterPanel: () => {
    return null;
  },
};

export default injectIntl(connect(mapStateToProps)(withRouter(FlightSideBar)));
